import React from 'react';

import { Title, Button } from 'components/commons';
import trafficIcon from 'assets/svg/traffic-signal.svg';

type RequestDeniedInQueueLayoutProps = {
    onOk(): void;
}

const RequestDeniedInQueueLayout: React.FC<RequestDeniedInQueueLayoutProps> = ({ onOk }) => (
    <div className="message-box-container denied-container">
        <div className="inner">
            <div className="screen">
                <div className="message-box">
                    <img className="icon" src={trafficIcon} />

                    <Title>colocamos você na fila de análise</Title>

                    <p className="text">
                        Seu pedido está sendo analisado com atenção para te trazermos a melhor oferta possível.
                    </p>

                    <p className="text bold">
                        assim que tivermos uma oferta, avisaremos por e-mail.
                    </p>
                </div>

                <Button className="mt-4" label="entendi" onClick={onOk} />
            </div>
        </div>
    </div>
);

export default RequestDeniedInQueueLayout;
